module.exports = __webpack_public_path__ + "static/media/cloud3.7bca23a5.png";